<div class="reports-status-section">
  <div class="reports-status-header">
    <h3>{{ 'reportsStatus' | translate }}</h3>
    <div class="reports-status-actions">
      <!-- TODO Illia: move all dashboard filters to the same component to avoid code duplication -->
      <app-ui-select
        class="vessel-select"
        [label]="'departmentSelector' | translate"
        [control]="vesselControl"
        [options]="vesselOptions()"
        [isMultiple]="false"
      ></app-ui-select>
      <div class="time-period-group">
        <app-ui-select
          class="period-select"
          [label]="'timePeriod' | translate"
          [control]="periodControl"
          [options]="periodOptions"
          [isMultiple]="false"
        ></app-ui-select>
        <app-ui-date-range-picker
          [control]="customRangeControl"
          [maxDate]="maxDate"
        ></app-ui-date-range-picker>
      </div>
    </div>
  </div>
  <div
    class="reports-widgets-container"
    *appLoader="(loadingActions | actionInProgress: true | async) === true"
  >
    <!-- Absolute values section -->
    <div class="absolute-values-section">
      <div class="absolute-values-header">
        <span class="absolute-values-title">{{ 'absoluteValuesTitle' | translate }}</span>
        <mat-icon
          class="info-icon"
          [matTooltip]="'absoluteValuesTooltip' | translate"
          matTooltipPosition="above"
        >
          info
        </mat-icon>
      </div>
      <div class="absolute-values-widgets">
        <!-- Open reports -->
        <app-ui-widget-card
          name="openReports"
          [value]="openReports"
          icon="visibility"
          iconColor="blue"
          [clickable]="true"
          [loading]="openReportsLoading"
          (click)="navigateToOpenReports()"
          [matTooltip]="'openReportsForSelectedDepartments' | translate"
        ></app-ui-widget-card>

        <!-- Due soon reports (my + all) -->
        <app-ui-widget-card
          [blocks]="dueSoonReportsData"
          [clickable]="true"
          [loading]="dueSoonReportsLoading"
          [matMenuTriggerFor]="dueSoonReportsMenu"
          #dueSoonReportsTrigger="matMenuTrigger"
          (blockClick)="dueSoonReportsTrigger.openMenu()"
        ></app-ui-widget-card>
        <mat-menu #dueSoonReportsMenu="matMenu">
          <button mat-menu-item (click)="openDueSoonReportsInOpen()">
            <mat-icon>visibility</mat-icon>
            <span>{{ 'openDueSoonReportsInOpenState' | translate }}</span>
          </button>
          <button mat-menu-item (click)="openDueSoonReportsInCompleted()">
            <mat-icon>check</mat-icon>
            <span>{{ 'openDueSoonReportsInCompletedState' | translate }}</span>
          </button>
        </mat-menu>

        <!-- Expired reports (my + all) -->
        <app-ui-widget-card
          [blocks]="expiredReportsData"
          [clickable]="true"
          [loading]="expiredReportsLoading"
          [matMenuTriggerFor]="expiredReportsMenu"
          #expiredReportsTrigger="matMenuTrigger"
          (blockClick)="expiredReportsTrigger.openMenu()"
        ></app-ui-widget-card>
        <mat-menu #expiredReportsMenu="matMenu">
          <button mat-menu-item (click)="openExpiredReportsInOpen()">
            <mat-icon>visibility</mat-icon>
            <span>{{ 'openExpiredReportsInOpenState' | translate }}</span>
          </button>
          <button mat-menu-item (click)="openExpiredReportsInCompleted()">
            <mat-icon>check</mat-icon>
            <span>{{ 'openExpiredReportsInCompletedState' | translate }}</span>
          </button>
        </mat-menu>
      </div>
    </div>

    <!-- Vertical divider -->
    <div class="reports-divider"></div>

    <!-- Period-based reports -->
    <div class="reports-widgets-row">
      <!-- Created reports -->
      <app-ui-widget-card
        name="createdReports"
        [value]="createdReports"
        [description]="!vesselControl.value?.length ? 'fromAllDepartments' : ''"
        icon="format_list_bulleted"
        iconColor="blue"
        [matTooltip]="'createdReportsForTimePeriodTooltip' | translate"
      ></app-ui-widget-card>

      <!-- Completed reports -->
      <app-ui-widget-card
        [routerLink]="reportRoutes.Completed"
        name="completedReports"
        [value]="completedReports"
        descriptionIcon="trending_up"
        descriptionColor="green"
        icon="check"
        iconColor="orange"
        [clickable]="true"
        [matTooltip]="'completedReportsForTimePeriodTooltip' | translate"
      ></app-ui-widget-card>

      <!-- Closed reports -->
      <app-ui-widget-card
        [routerLink]="reportRoutes.Closed"
        name="closedReports"
        [value]="closedReports"
        descriptionIcon="arrow_right_alt"
        descriptionColor="cyan"
        icon="key"
        iconColor="green"
        [clickable]="true"
        [matTooltip]="'closedReportsForTimePeriodTooltip' | translate"
      ></app-ui-widget-card>
    </div>
  </div>
</div>
